import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import imageOne from '../../resource/donations/buildingFound/2.png'
import imageFour from '../../resource/donations/buildingFound/3.png'
import imageFive from '../../resource/donations/buildingFound/4.png'
import imageThree from '../../resource/donations/buildingFound/1.png'
import qrcode from '../../resource/donations/annual-sub/qr.png'
import TitleChnage from '../../Hook/TitleChnage'
import imageSix from "../../resource/donations/buildingFound/g.png";
const BuildingFound = () => {
    TitleChnage("Building Found")
    const navigate = useNavigate();
      const handleClick = (event) => {
        const pathMap = {
            buildingFundRequest: "/buildingFundRequest",
        };
    
        const path = event.currentTarget.id;
        const targetPath = pathMap[path];
    
        if (targetPath) {
          navigate(targetPath);
        }
      };
  return (
    <div className="buldingfound-page inside-pages">
    <div className="right-box">
        <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
    </div>

    <h1 className='font-main  p-4 mt-4'>Building Fund</h1>

    <div className="text-center mt-6 h4-bold">
        <div>
            <p >Maha Sangha, conqueror of sin, </p>
            <p >Unhindered, no doubt of vision, </p>
            <p >Marching to truth with sincere resolution,</p>
            <p >Reaching toward the bright light of wisdom.</p>

            <p className=" mt-5">Hands in hand to support the Monastery,</p>
            <p >Deeds of merit accumulate,</p>
            <p >The road to a wealthy life, pleasant,</p>
            <p >Worldly happiness in this life and the next.</p>

        </div>
    </div>

    <p className="mt-6 h4 p-4">In support of the continued growth and expansion of the Bhaddeka Vihari Monastery and Meditation Centre, we invite you to contribute to our Building Fund. Your generous donations will help realize our vision of enhancing the facilities for both the Sangha and the lay community, ensuring that we can accommodate more practitioners and provide enhanced amenities for spiritual practice.</p>
    <p className="mt-5 h4 p-4">As the Sangha relies on the generosity of the community, your contributions play a vital role in fueling ongoing and future projects. These funds will directly support the establishment of the proposed Monastery and Retreat Centre, which will serve as a peaceful and welcoming space for all those seeking spiritual growth.</p>
    <p className="mt-5 h4 p-4">This expansion will strengthen the serene environment necessary for deepening spiritual practice, welcoming new practitioners, and fostering a thriving community. It will earn the appreciation of all beings who strive for goodness, creating a legacy of merit and positive influence.</p>
    <p className="mt-5 h4 p-4">Contribute now and help us build a lasting, inclusive, and peaceful space for spiritual growth that will benefit generations to come.</p>
    <p className="mt-5 h4 p-4">For Australian taxpayers, donations to the Building Fund are tax-deductible.</p>

    <p className="mt-5 h4 p-4">We thank you for your support in helping us realize this noble endeavor.</p>
    

    <div className='btn-group2 mt-6'>
        <img src={imageFour} alt="Right Top Image" width={300} />
        <img src={imageFive} alt="Right Top Image" width={300} />
    </div>

    

    <p className="h4 text-black p-4 text-center mt-6">Ongoing Projects :</p>
    <p className="h4 p-4 text-center mt-4"><a href="#">https://test.evisionlk.com/about-us/</a></p>

    <div className="p-4 mt-6 text-center">
    <div className="mt-6 calander-box align-item-center">
            <div className="c-details text-left">
                <h2 className='intro-text '>Futher More Details : </h2>
                <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                <p className="font-p">Mr Gamini : 0422 069 359</p>
                <p className="font-p">WhatsApp : 0422 069 359</p>
                <p className="font-p">E-mail : info@bvp.org.au</p>
            </div>
            <div className="d-button">
            <div className="btn-group mt-5">
        <img
          src={imageSix}
          alt="Right Top Image"
          width={300}
          id="buildingFundRequest"
          onClick={handleClick}
          className="curser-pointer"
        />
      </div>
            </div>
        </div>
        </div>

        <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image"  width={600} />
    </div>

</div>
  )
}

export default BuildingFound